import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const BRAND_BLUE = '#0B3D6E';
const BRAND_TEAL = '#0F6E56';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      navigate('/admin/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Identifiants incorrects');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:'100vh', background:'#f1f5f9', display:'flex', alignItems:'center', justifyContent:'center', padding:'1rem' }}>
      <div style={{ background:'#fff', borderRadius:16, boxShadow:'0 4px 24px rgba(0,0,0,0.1)', padding:'2rem', width:'100%', maxWidth:360 }}>

        {/* Logo + Brand */}
        <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:'1.8rem' }}>
          <div style={{ width:44, height:44, background:BRAND_BLUE, borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, position:'relative' }}>
            <svg width="26" height="26" viewBox="0 0 40 40">
              <circle cx="20" cy="20" r="15" fill="none" stroke="white" strokeWidth="1.5" strokeDasharray="65 20"/>
              <rect x="14" y="17" width="12" height="6" rx="1.5" fill="white"/>
              <rect x="17" y="14" width="6" height="12" rx="1.5" fill={BRAND_TEAL}/>
            </svg>
          </div>
          <div>
            <div style={{ fontSize:15, fontWeight:600, color:BRAND_BLUE, lineHeight:1.2 }}>LOMED MEDICARE</div>
            <div style={{ fontSize:11, color:'#94a3b8', marginTop:2 }}>Espace Administration</div>
          </div>
        </div>

        <h2 style={{ fontSize:20, fontWeight:600, marginBottom:6 }}>Connexion</h2>
        <p style={{ fontSize:13, color:'#94a3b8', marginBottom:'1.5rem' }}>Accès réservé aux administrateurs</p>

        <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:14 }}>
          <div>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:'#64748b', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:6 }}>Identifiant</label>
            <input type="text" value={username} onChange={e=>setUsername(e.target.value)}
              placeholder="admin"
              style={{ width:'100%', border:'1px solid #e2e8f0', borderRadius:8, padding:'10px 12px', fontSize:14, outline:'none', background:'#f8fafc', boxSizing:'border-box' }}
              onFocus={e=>e.target.style.borderColor=BRAND_BLUE}
              onBlur={e=>e.target.style.borderColor='#e2e8f0'}/>
          </div>
          <div>
            <label style={{ display:'block', fontSize:11, fontWeight:600, color:'#64748b', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:6 }}>Mot de passe</label>
            <input type="password" value={password} onChange={e=>setPassword(e.target.value)}
              placeholder="••••••••"
              style={{ width:'100%', border:'1px solid #e2e8f0', borderRadius:8, padding:'10px 12px', fontSize:14, outline:'none', background:'#f8fafc', boxSizing:'border-box' }}
              onFocus={e=>e.target.style.borderColor=BRAND_BLUE}
              onBlur={e=>e.target.style.borderColor='#e2e8f0'}/>
          </div>
          <button type="submit" disabled={loading} style={{
            background: loading ? '#94a3b8' : BRAND_BLUE, color:'#fff', border:'none',
            padding:'12px', borderRadius:8, fontSize:14, fontWeight:600, cursor:'pointer',
            marginTop:4, transition:'background 0.2s'
          }}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <p style={{ textAlign:'center', fontSize:11, color:'#cbd5e1', marginTop:'1.5rem' }}>
          Demo : admin / apex2024
        </p>
      </div>
    </div>
  );
}

